var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "app" } },
    [
      _c("header-component"),
      _vm._v(" "),
      _vm.isAuthLoading === true ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _c("footer-component", { staticClass: "footer" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }